import { colors } from 'theme'

export const defaultThemeStyles = {
    localVideo: colors.grey,
    video: colors.blackLight,
}
